import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

import constants from 'constants/index'

const TicketFilters = ({
  filter,
  filterFields,
  setFilterFields,
  answerOptionTickets = [],
  users = [],
}) => {
  const { TITULAR_STATS_CARD_ITEMS } = constants.tickets

  const filterAnswerOptionTickets =
    answerOptionTickets.map((option) => ({
      id: option.id,
      name: option.title,
    })) || []

  const handleStatusChange = (value) => {
    setFilterFields({ ...filterFields, companyStatusId: value })
  }

  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <select
        multipleselectinput="true"
        name="responsible_ids"
        label="Responsáveis"
        optionvalues={users}
      />
      <input textfieldinput="true" label="Solicitante" name="userName" />
      <select
        multipleselectinput="true"
        name="category_ids"
        label="Categorias"
        optionvalues={filterAnswerOptionTickets}
      />
      <input
        datepickerinput="true"
        label="Data de confirmação"
        name="confirmedAt"
      />
      <input
        datepickerinput="true"
        label="Prazo de atendimento"
        name="companyDeadlineAt"
      />
      <select
        textfieldinput="true"
        label="Status"
        name="companyStatusId"
        value={filterFields?.companyStatusId || ''}
        onChange={(e) => handleStatusChange(e.target.value)}
      >
        <option value=""></option>
        {TITULAR_STATS_CARD_ITEMS.map((item, index) => (
          <option key={index} value={String(item.id)}>
            {item.subTitle}
          </option>
        ))}
      </select>
    </Filters>
  )
}

TicketFilters.propTypes = {
  filter: PropTypes.object.isRequired,
  filterFields: PropTypes.object.isRequired,
  setFilterFields: PropTypes.func.isRequired,
  answerOptionTickets: PropTypes.array,
  users: PropTypes.array,
}

export default TicketFilters
